import { Form } from "react-bootstrap";
import { getProductInfo } from "src/utils/storage/product";
import { PRICE_LIST, PriceListType } from "src/config/priceTypeList";
import "./SitePay.style.scss";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import CommonFormProvider from "src/context/Modal/Form/CommonForm.provider";
import RightDetailBox from "./RightDetailBoxNew";
import { IGetMyServiceListRes } from "src/service/types/console.type";
import { SetStateAction } from "react";
import { useFormikContext } from "formik";
import ConfirmPolicy from "../Common/Form/FormItem/ConfirmPolicy";
import SelectPayType from "../Common/Form/FormItem/SelectPayType";
import PayTerm from "../Common/Form/FormItem/PayTerm";
import CompanyName from "../Common/Form/FormItem/CompanyName";
import LicenseCount from "../Common/Form/FormItem/LicenseCount";
import { useTranslation } from "react-i18next";

interface ISitePayUIProps {
  confirmPolicy: boolean;
  // payApply: ({
  //   orderID,
  //   subscriptionID,
  // }: {
  //   orderID: string;
  //   subscriptionID: string;
  // }) => void;

  cardNumber: string;
  // priceList: any;
  userPerPrice: number;
  userPerPriceYear: number;
  currency: string;
  payCompany: string;
  isInit: boolean;
  isShowPay: boolean;

  // 모달 관련
  // hideModal: () => void;
  openTermsService: () => void;
  openPrivatePolicy: () => void;
  openPaidTermsService: () => void;

  planId: string; // paypal
  serviceNo: number;

  serviceList: IGetMyServiceListRes[];

  toggleMoreInfo: () => void;
  toggleMoreInfoOn: boolean;

  isRenew: boolean;
  startDate: string;
  // showPolicy?: any;
  // tabTarget: any;

  // 결제 관련
  inicisData: any;
  selectPayType: string;
  selectAppList: string[];
  setSelectAppList: React.Dispatch<SetStateAction<string[]>>;

  showExtDetail: boolean;
  openExtDetailModal: (e: any, uid: string) => void;
  hideExtDetailModal: () => void;
  // showExtDetailUid: string;
  toggleTaxInvoidFields: () => void;
  showTaxInvoiceFields: boolean;
  taxInvoiceInfo: any;
  handleChangeTaxInvoice: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeTaxRequestDate: (date: Date | null) => void;
}

const SitePayUI = ({
  userPerPrice,
  userPerPriceYear,
  currency,
  isInit,
  isShowPay,
  isRenew,
  inicisData,
  payCompany,
  // payApply,
  startDate,
  planId,
  showTaxInvoiceFields,
  toggleTaxInvoidFields,
  taxInvoiceInfo,
  handleChangeTaxInvoice,
  handleChangeTaxRequestDate,
  selectAppList,
  setSelectAppList,
}: ISitePayUIProps) => {
  const { setFieldValue, values, handleChange } = useFormikContext<any>();
  const { t } = useTranslation();
  const productInfo =
    PRICE_LIST({ t })[getProductInfo().key].filter(
      (item: PriceListType) => item.key === values?.priceType
    ).length > 0
      ? PRICE_LIST({ t })[getProductInfo().key].filter(
          (item: PriceListType) => item.key === values?.priceType
        )[0]
      : { key: "", name: "", featuresCnt: 0, upcCnt: -1 };
  const productName = getProductInfo().name;
  // const productKey = getProductInfo().key;
  // const changePriceName = (priceType: string) => {
  //   priceNameMap({ product: getProductFromSessionStorage(), priceType });
  // };

  // const setGoodName = () => {
  //   const product = getProductFromSessionStorage();
  //   return productInfoNameMap[product].name;
  // };
  // const closeUrl = window.location.href;
  // const returnUrl =
  //   window.location.origin +
  //   "/eco-cloud/wapi/cloud/pay/service/returnUrl/" +
  //   inicisData.oid +
  //   "/" +
  //   getProductFromSessionStorage();
  // const billPrint_msg = t(
  //   "siteManagement.paymentHistory.bill.detail.includeVat"
  // );

  return (
    <CommonFormProvider>
      <div className="containerBox">
        <div className="container">
          {/* {isLoading ? <Loading /> : ''} */}
          {!isShowPay ? (
            <div className="site">
              <h3 className="site__title">
                {productName + " Cloud " + productInfo.name}
              </h3>
              <p className="site__desc">
                {values?.priceType &&
                values?.priceType !== "" &&
                getProductFromSessionStorage() === "WRAPSODY"
                  ? t(`siteType.subTitle`, { 0: values?.priceType as string })
                  : ""}
                {/* {priceType &&
              priceType !== "" &&
              getProductFromSessionStorage() === "WRAPSODY"
                ? t(
                    `siteType.subTitle`,
                    changePriceName(priceType)
                  )
                : ""} */}
              </p>
              <div className="flex justify-space-between">
                <div className="flex-item box box__lt bg-white">
                  <Form className="form">
                    <h4 className="form-title">
                      {t("siteType.basic.detail.plan.title")}
                    </h4>

                    {/* 사용자 수 */}
                    <LicenseCount
                      licenseCount={values.licenseCount}
                      handleChange={handleChange}
                      isRenew={isRenew}
                    />
                    {/* 회사 이름 */}
                    <CompanyName
                      companyName={values.companyName}
                      handleChange={handleChange}
                    />
                    {/* 결제 주기 */}
                    <PayTerm
                      currency={currency}
                      handleChange={handleChange}
                      payTerm={values.payTerm}
                      priceType={values?.priceType}
                      userPerPrice={userPerPrice}
                      userPerPriceYear={userPerPriceYear}
                    ></PayTerm>

                    {/* 결제 정보 */}
                    <SelectPayType
                      currency={currency}
                      handleChange={handleChange}
                      priceType={values?.priceType}
                      selectPayType={values.selectPayType}
                    />
                    {/* 통합 이용약관, 개인정보처리방침 */}
                    <ConfirmPolicy
                      confirmPolicy={values.confirmPolicy}
                      handleChange={handleChange}
                    />
                  </Form>
                </div>
                <RightDetailBox
                  payCompany={payCompany}
                  // licenseCount={licenseCount}
                  // payTerm={payTerm}
                  userPerPriceYear={userPerPriceYear}
                  userPerPrice={userPerPrice}
                  currency={currency}
                  inicisData={inicisData}
                  startDate={startDate}
                  planId={planId}
                  showTaxInvoiceFields={showTaxInvoiceFields}
                  toggleTaxInvoidFields={toggleTaxInvoidFields}
                  taxInvoiceInfo={taxInvoiceInfo}
                  handleChangeTaxInvoice={handleChangeTaxInvoice}
                  handleChangeTaxRequestDate={handleChangeTaxRequestDate}
                  selectAppList={selectAppList}
                  setSelectAppList={setSelectAppList}
                />
              </div>
            </div>
          ) : isInit ? (
            ""
          ) : (
            ""
            // 사이트 생성하기 UI인데 흐름상 안써도될듯
            // <div className="site">
            //   <h3 className="site__title">
            //     {t("siteType.paymentSuccess")}
            //   </h3>
            //   <p className="site__desc">
            //     {t("siteManagement.subTitle")}
            //   </p>
            //   <div className="trialApply">
            //     <div className="image" />
            //   </div>
            //   <div className="applyButton">
            //     <button
            //       type="button"
            //       onClick={makeSite}
            //       className="btn btn-green"
            //     >
            //       {t("siteManagement.createBtn")}
            //     </button>
            //   </div>
            // </div>
          )}
        </div>
      </div>
    </CommonFormProvider>
  );
};

export default SitePayUI;
